import { render, staticRenderFns } from "./SaveBlockDialog.vue?vue&type=template&id=6812f925&scoped=true"
import script from "./SaveBlockDialog.vue?vue&type=script&lang=js"
export * from "./SaveBlockDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveBlockDialog.vue?vue&type=style&index=0&id=6812f925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812f925",
  null
  
)

export default component.exports